import { AdSpendMapControls } from './AdSpendMapControls';
import { MapDot } from '../../../SharedComponents/Map/Dots/Dots';
import { useAdSpendMapData } from './AdSpendMap.hooks';
import { CustomerAnalyticsPage } from '../../../SharedComponents/CustomerAnalyticsPage';
import { AdSpendMapSidebar } from './AdSpendMapSidebar';
import { useSidebarTitle } from '../../../../hooks/useSidebarTitle';
import dynamic from 'next/dynamic';
import { PageLoading } from '../../../SharedComponents/PageLoading';

const MapWithGeoJson = dynamic(
  () => import('../../../SharedComponents/Map/MapWithGeoJson').then((mod) => mod.MapWithGeoJson),
  {
    ssr: false,
    loading: () => <PageLoading />,
  },
);

export const AdSpendMap = () => {
  const {
    hiddenPackages,
    setHiddenPackages,
    allPackages,
    finalDisplayMode,
    propertiesByPackageType,
    propertiesToRender,
    renderDotNumber,
    isCalculatingAdSpend,
    allDots,
  } = useAdSpendMapData();
  const sidebarTitle = useSidebarTitle();

  return (
    <CustomerAnalyticsPage
      header="Ad spend"
      subheader="Source: Zillow internal data"
      sidebarTitle={sidebarTitle}
      sidebar={<AdSpendMapSidebar propertiesToRender={propertiesToRender} finalDisplayMode={finalDisplayMode} />}
    >
      <MapWithGeoJson renderDotNumber={renderDotNumber} loading={isCalculatingAdSpend}>
        <AdSpendMapControls
          hiddenPackages={hiddenPackages}
          setHiddenPackages={setHiddenPackages}
          allPackages={allPackages}
          finalDisplayMode={finalDisplayMode}
          propertiesByPackageType={propertiesByPackageType}
        />
        {allDots.map(({ key, payload }) => (
          <MapDot key={key} payload={payload} />
        ))}
      </MapWithGeoJson>
    </CustomerAnalyticsPage>
  );
};
